/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/Metadata
 * @desc Metadata filter
 */

import FilterPostNewIndexMetadataExperimentWorkflowForm from 'labstep-web/components/FilterPost/NewIndex/MetadataExperimentWorkflow/Form';
import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import { Metadata } from 'labstep-web/models/metadata';
import type React from 'react';
import type { FilterPostNewIndexMetadataExperimentWorkflowProps } from './types';

export const FilterPostNewIndexMetadataExperimentWorkflow: React.FC<
  FilterPostNewIndexMetadataExperimentWorkflowProps
> = ({ addPostFilter, defaultValues, replace, ...rest }) => (
  <Modal
    header={`Filter by ${Metadata.getHumanReadableEntityName(
      false,
      true,
    )}`}
    viewComponent={({ toggleModal }): React.ReactNode => (
      <ActionComponent
        onClick={toggleModal}
        type="option"
        icon={ICONS.metadata.secondary}
        text="Filter by Data Field"
      />
    )}
    content={({ toggleModal }): React.ReactNode => (
      <FilterPostNewIndexMetadataExperimentWorkflowForm
        addPostFilter={addPostFilter}
        onDone={toggleModal}
        defaultValues={defaultValues}
        replace={replace}
      />
    )}
    {...rest}
  />
);
